import React, {Fragment} from "react";
import Select, { Async } from "react-select";
import { Prompt } from "react-router-dom";
import moment from "moment";
import { RadioGroup, Radio } from "react-radio-group";
import Dialog from "../../../components/dialog";
import Overlay from "../../../components/overlay";
import {inspectionPrioritySelect,searchWHTool} from "../../../backend/machines";

export default function() {
  const {
    loading,
    dialogVisible,
    uploading,
    tool_id,
    status,
    require_swap,
    priority,
    inspection_pass,
    inspection_note,
    one_way_swap,
    created_at,
    savedForm,
    tool,
    faulty_list,
    t_faulty_list,
    new_t_code
  } = this.state;

  return (
    <div className="form">
      {loading && <Overlay />}
      <button className="prev_inspection" onClick={this._navigate(`/tool-history/${tool_id}`)}>
        Previous Inspections
      </button>

      {!savedForm && [
        <label className={savedForm ? "disabled" : ''}>Tool Number</label>,
        <Select
          value={{
            label: tool !== null ? tool.code : '',
            value: tool !== null ? tool.id : '',
          }}
        />
      ]}

      <label className={savedForm ? "disabled" : ''}>Test and Tag</label>
      <input
        disabled
        type="date"
        value={moment(created_at).format("YYYY-MM-DD")}
      />

      <label className={savedForm ? "disabled" : ''}>Tool Status</label>
      <RadioGroup
        className={`radio-group ${savedForm ? "disabled" : ''}`}
        name={`machine-${tool_id}`}
        selectedValue={status}
        onChange={
            !savedForm ? this._editTool(1, "radio", "status") : undefined
        }
        >
        <div>
            <Radio value={"Available"} /> <span>Passed</span>
        </div>
        <div>
            <Radio value={"Faulty"} /> <span>Issue</span>
        </div>
        <div>
            <Radio value={"Not Inspected"} /> <span>Not Inspected</span>
        </div>
        </RadioGroup>
        {( status === 'Faulty' || (savedForm && status === 'Faulty')) ? (
            <div>
            <label className={savedForm ? "disabled" : ''}>Equipment Fault</label>
            
            {!savedForm ? (
              <Fragment>
                <Select name={`faulty-${tool_id }`}
                  options={ !savedForm && t_faulty_list}
                  onChange={
                    !savedForm ? this._editTool(1, "select", "faulty_reason") : undefined
                }></Select>

                {( (this.state.tool.faulty_reason !== undefined && this.state.tool.faulty_reason.other === 1) || (savedForm && this.state.tool.faulty_reason.other === 1)) && [
                  <label className={savedForm ? "disabled" : ''}>Please provide a brief description of the fault</label>,
                  <textarea
                  onChange={!savedForm ? this._editTool(1, "input", "faulty_reason_text") : undefined}
                  />
                ]}
              </Fragment>
            ) : (
                <textarea className={savedForm ? "disabled" : ''} value={ faulty_list !== null && (JSON.parse(faulty_list)).text } />
            )}
          </div>
        ) : null}
      {/* <Select
        isDisabled={savedForm}
        value={{ value: tool !== null ? tool.hire_status : '', label: tool !== null ? tool.hire_status : '' }}
        onChange={this._change("status", true, true)}
        options={machineStatusesSelect}
      /> */}

      <label className={savedForm ? "disabled" : ''}>Inspection Passed</label>
      <RadioGroup
        className={`radio-group ${savedForm && "disabled"}`}
        name="inspection_pass"
        selectedValue={inspection_pass}
        onChange={!savedForm ? this._change("inspection_pass", true) : undefined }
      >
        <div>
          <Radio value={true} /> <span>Yes</span>
        </div>
        <div>
          <Radio value={false} /> <span>No</span>
        </div>
      </RadioGroup>

      <label className={savedForm ? "disabled" : ''}>Tool Swap</label>
      <RadioGroup
        className={`radio-group ${savedForm && "disabled"}`}
        name="require_swap"
        selectedValue={require_swap}
        onChange={!savedForm ? this._change("require_swap", true) : undefined }
      >
        <div>
          <Radio value={true} /> <span>Yes</span>
        </div>
        <div>
          <Radio value={false} /> <span>No</span>
        </div>
      </RadioGroup>

      {require_swap && (
        <Fragment>
            <label className={savedForm ? "disabled" : ''}>One Way Swap</label>
            <RadioGroup
            className={`radio-group ${savedForm ? "disabled" : ''}`}
            name="one_way_swap"
            selectedValue={ one_way_swap}
            onChange={!savedForm ? this._change("one_way_swap", true) : undefined}
            >
            <div>
                <Radio value={true} /> <span>Yes</span>
            </div>
            <div>
                <Radio value={false} /> <span>No</span>
            </div>
            </RadioGroup>
            
        </Fragment>
        )}
      { (require_swap && !one_way_swap) && [
        <label className={savedForm ? "disabled" : ''}>New Tool Number</label>,
        <Async
          loadOptions={searchWHTool}
          onChange={!savedForm ? this._change("new_tool_id", true, true) : undefined }
        />
      ]}
      
      
      

      <label className={savedForm ? "disabled" : ''}>Priority</label>
      <Select
        isDisabled={savedForm}
        value={{ value: priority, label: priority }}
        onChange={this._change("priority", true, true)}
        options={inspectionPrioritySelect}
      />

      <label className={savedForm ? "disabled" : ''}>Note</label>
      <textarea
        value={inspection_note !== null ? inspection_note : ''}
        onChange={!savedForm ? this._change("inspection_note") : undefined }
      />

      {!savedForm && (
        <button disabled={!this._valid()} onClick={this._toggleSubmitDialog}>
          Save
        </button>
      )}
      {dialogVisible && (
        <Dialog close={this._toggleSubmitDialog}>
          <div className="confirm-dialog">
            <h4>Ready to submit?</h4>
            <p></p>
            <button
              onClick={() => {
                this._upload();
                this._toggleSubmitDialog();
              }}
            >
              Confirm
            </button>
          </div>
        </Dialog>
      )}
      {uploading && <Dialog loader />}
      {[
        !savedForm && (
          <Prompt message="You are cancelling. Your progress will be lost." />
        )
      ]}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/tools/tool-form/view.js